import { useMemo } from 'react';

// rwx = 421
const READ_BIT = 1 << 2;
const WRITE_BIT = 1 << 1;
const EXTD_BIT = 1 << 0;

/**
 * Returns an object with (r)ead, (w)rite, and e(x)tended booleans.
 * @param perm should be a number or undefined, to comply with the object returned from useModulePermissions
 * @returns { r: canRead, w: canWrite, x: canExtended }
 */
const useCanReadWrite = (
  perm: number | undefined
): { r: boolean; w: boolean; x: boolean } => {
  return useMemo(() => {
    const p = typeof perm === 'number' ? perm : 0;
    return { r: !!(p & READ_BIT), w: !!(p & WRITE_BIT), x: !!(p & EXTD_BIT) };
  }, [perm]);
};

export { useCanReadWrite };
